import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Toast} from 'primereact/toast';
import {MultiSelect} from 'primereact/multiselect';
import {Calendar} from 'primereact/calendar';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';
import moment from 'moment';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, CERTIFICATE_MASTER_SUBMENU_ID} from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import * as actions from '../../../store/actions/index';

class AddCertificateMaster extends Component {
    state = {
        roles : [],
        type: 'add',
        Id:null,
        UserId:null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        UserId1: '',              
        FirstName : '',
        MiddleName : '',
        LastName : '',
        EmailId: '',
        Password : '',
        MobileNumber : '',
        Activedirectory : false,
        Adloginid : '',
        Disablelogin : false,
        IsActive : false,
        createdBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate : new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch : false,
        //starts here
        filePath:'',
        fileName:'',
        fileExtension:'',
        fileUploaded: false,
        attachmentData:[]
    }

    componentDidMount(){
        this.getAccess = HASACCESS(CERTIFICATE_MASTER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GetWPCertificate');  
        this.props.getMasterKeywordList('Employee');
        let type = this.props.match.params.type;
        this.setState({type});

        if(type !== 'add'){
            this.timer();
        }
    }

    timer = () =>{
        this.intervalID = setInterval(()=> {
            this.fetchSingleProcess();
        },2000)
    }    
    componentWillUnmount(){
        if(this.props.tableLists!==undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () =>{

        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];
        if(this.props.tableLists!==undefined) {
            storageItems = this.props.tableLists;
            clearInterval(this.intervalID);
        }
        if(storageItems){
            let filterData = storageItems.find(el => el.employeeDocumentID == id);
            if(filterData){
                let employeeList = this.props.GetEmployeedropdown;
                let id = filterData.employeeID.toString();
                let employeeId = employeeList.find(el => el.value == id).value || '';

                let data = {
                    employeeId,
                    documentType: filterData.docDocumentType,
                    documentName: filterData.documentName,
                    documentNumber: filterData.docDocumentNumber,
                    documentIssuePlace: filterData.docIssuePlace,
                    documentIssueDate: new Date(filterData.docIssueDate),
                    documentExpiryDate: new Date(filterData.docExpiryDate),
                    isActive : filterData.isActive,
                    filePath: filterData.uploadPath,
                    fileName: filterData.fileName,
                    fileExtension: filterData.extension,
                    fileUploaded: true,
                    attachmentData : [{
                        extension: filterData.extension,
                        uploadPath: filterData.uploadPath,
                        fileName: filterData.fileName,
                    }]
                }

                this.setState(data);
                
            }
        }

    }


    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    add = () => {
        let docId = this.props.match.params.id;
        if(this.state.employeeId == null || this.state.employeeId == undefined || this.state.employeeId == ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Select Employee before submitting '});
            return;
        } else if (this.state.documentType == null || this.state.documentType == undefined || this.state.documentType == ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Select Document Type before submitting '});
            return;
        } else if (this.state.documentName == null || this.state.documentName == undefined || this.state.documentName == ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Enter Document Name before submitting '});
            return;
        } else if (this.state.documentNumber == null || this.state.documentNumber == undefined || this.state.documentNumber == ''){ 
            this.growl.show({severity: 'error', summary: null, detail: 'Enter Document Number before submitting '});
            return;
        } else if (this.state.documentIssuePlace == null || this.state.documentIssuePlace == undefined || this.state.documentIssuePlace == ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Enter Document Issue Place before submitting '});
            return;
        } else if (this.state.documentIssueDate == null || this.state.documentIssueDate == undefined || this.state.documentIssueDate == ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Enter Document Issue Date before submitting '});
            return;
        } else if (this.state.documentExpiryDate == null || this.state.documentExpiryDate == undefined || this.state.documentExpiryDate == ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Enter Document Expiry Date before submitting '});
            return;
        } else if (this.state.fileUploaded == false){
            this.growl.show({severity: 'error', summary: null, detail: 'Please upload Document before submitting '});
            return;
        }
        // employeeId: null,
        // documentType: null,
        // documentName: '',
        // documentNumber: '',
        // documentIssuePlace: '',
        // documentIssueDate: null,
        // documentExpiryDate: null,
        // isActive: false,
        // filePath:'',
        // fileName:'',
        // fileExtension:'',
        // fileUploaded: false, 
        // attachmentData :[]
        

        let data = {
            EmployeeDocumentId: this.state.type == 'add' ? "00000000-0000-0000-0000-000000000000" : docId,
            EmployeeId: this.state.employeeId,
            DocType:'null',
            DocDocumentType: this.state.documentType,
            DocDocumentName: this.state.documentName,
            DocDocumentNo: this.state.documentNumber,
            DocIssuPlace: this.state.documentIssuePlace,
            DocIssuDate: moment(this.state.documentIssueDate).format('MM/DD/YYYY'),
            DocExpiryDate: moment(this.state.documentExpiryDate).format('MM/DD/YYYY'),
            Createdby: this.state.employeeId,
            Createddate: moment(this.state.documentIssueDate).format('MM/DD/YYYY'),
            Updatedby: this.state.employeeId,
            Updateddate: moment(this.state.documentIssueDate).format('MM/DD/YYYY'),
            CompanyId: this.props.loggedUserDetail.CompanyId,
            IsActive: this.state.isActive,
            UploadPath:this.state.filePath,
            FileName:this.state.fileName,
            Extension:this.state.fileExtension,
        }
   
        
        if(this.state.type === 'add'){
        this.props.processDynamicData('WPCertificate','add',data,'');
        } else if(this.state.type === 'edit'){
            this.props.processDynamicData('WPCertificate','edit',data,'');
        }


    }

    handleAttachment = (data, type) => {
        if(type == 'delete'){
            this.setState({filePath:'', fileName:'', fileExtension:'', fileUploaded: false, attachmentData :[]});
        } else if(type == 'add') {
            let filePath = data[0].filePath;
            let fileName = data[0].fileName;
            let fileExtension = data[0].fileExtension;
            this.setState({
                filePath, 
                fileName, 
                fileExtension, 
                fileUploaded: true, 
                attachmentData : [{
                extension: data[0].fileExtension,
                uploadPath: data[0].filePath,
                fileName: data[0].fileName,
            }]});
        }
    }

    resetData = () => {
        var data = {
            //
            employeeId: null,
            documentType: null,
            documentName: '',
            documentNumber: '',
            documentIssuePlace: '',
            documentIssueDate: null,
            documentExpiryDate: null,
            isActive: false,
            filePath:'',
            fileName:'',
            fileExtension:'',
            fileUploaded: false, 
            attachmentData :[]
        }
        this.setState(data);
    }
  
    render() {   
        if(this.props.success){
            REDIRECT_TO_URL('/Certificate-Master/',this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        
        let roleOptions = [];
        if(this.props.Role && this.props.Role.length > 0 ){
            roleOptions = this.props.Role;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/Certificate-Master/';
        if(this.props.userDetail && this.props.match.params.id!==undefined){
            if(this.props.userDetail.userId === this.props.match.params.id){
                redirectURL = "/dashboard";
            }
        }

        let documentTypeValues = [{label: "Safety Controller", value:"SafetyController"}, {label: "Acceptor", value:"Acceptor"},];
        

        return (
            <div className="p-grid">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>{this.state.type} Status</h1>
     
                        <div className="p-grid mt1">
                           
                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Employee <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <Dropdown className="p-col-12" placeholder="Select Employee" options={this.props.GetEmployeedropdown} value={this.state.employeeId} name="employeeId" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>			

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Select Document Type<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <Dropdown className="p-col-12" placeholder="Select Document Type" options={documentTypeValues} value={this.state.documentType} name="documentType" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Document Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText  className="p-col-12" name="documentName" placeholder="Document Name" value={this.state.documentName} onChange={this.change}/>
                                </div>	


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Document Number <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText  className="p-col-12" name="documentNumber" placeholder="Document Number" value={this.state.documentNumber} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Document Issue Place <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText  className="p-col-12" name="documentIssuePlace" placeholder="Document Issue Place" value={this.state.documentIssuePlace} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Document Issue Date <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <Calendar  className="width100" name="documentIssueDate" placeholder="Document Issue Date" value={this.state.documentIssueDate} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Document Expiry Date <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <Calendar  className="width100" name="documentExpiryDate" placeholder="Document Expiry Date" value={this.state.documentExpiryDate} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Is Active </label>
                                </div>
                                <div className="p-col-12 ">
                                <InputSwitch checked={this.state.isActive} value={this.state.isActive} onChange={this.change} name="isActive" />
                                </div>	

                            </div>
                            <div className="p-col-12 p-md-12 p-lg-12">
                                <Attachments 
                                handleAttachment = {this.handleAttachment} 
                                folderName = 'EmployeeDocument'
                                reloadedValues = {this.state.attachmentData}
                                heading = {'Certificate Documents'}
                                isReloaded = {
                                    ((this.props.match.params.type == 'add') || (this.props.match.params.type == 'edit')) ? false : true}
                                /> 
                            </div> 
                            <div className="p-col-12 p-lg-12">

                                <FooterButton access={accessButton} disabled={false} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                            
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        Role : (state.keyword.Role!==undefined) ? state.keyword.Role : [],
        tableLists : state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(AddCertificateMaster);